import Big from 'big.js';
import type { Bound, LinkerContext } from '../types';

// Bindings are the rounded per-row totals returned by buildInvoice.
export function resolveClientPONumber({ linkable, entities }: LinkerContext, bound: Bound): string {
  const poNumbers = new Set<string>();

  for (const row of linkable) {
    const amount = bound[row.id];
    if (amount === undefined || Big(amount).eq(0)) {
      continue;
    }

    const poNumber = entities.block[row.block_id].final_client_po_number;
    if (poNumber) {
      poNumbers.add(poNumber);
    }
  }

  return Array.from(poNumbers).sort().join('; ');
}
